import {useEffect, useState} from "react";
import styled from 'styled-components';

import {FormControl, FormLabel, Input, Stack, Textarea} from "@chakra-ui/react";
import {useHistory} from "react-router-dom";
import {Footer, Fullscreen, Main} from '../../components/fullscreen_view';
import Form from "../../components/form";
import useFeedback from "../../utils/use_feedback";
import {FixedTopBar} from "../../components/top_bar";
import {useCreateMessage} from "../../api/message";
import {useQuery} from "../../utils/router";
import {useSaveClicked} from "../../store";
import {themecolors} from "../../utils/themecolors";

const Send = styled(({className}) => {
    const {busy, error, feedbackCh} = useFeedback(false);

    const history = useHistory();
    const {to} = useQuery();

    const [message, setMessage] = useState({
        recipient: to,
        subject: '',
        content: '',
    });
    const set = (name) => (value) => setMessage((message) => ({...message, [name]: value}));

    const createMessage = useCreateMessage(feedbackCh);
    const save = async () => {
        try {
            const {messages} = await createMessage(message);
            history.replace(`/message/${messages[0].id}`);
        } catch {
            // error is displayed
        }
    };

    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    await save();
                    setSaving(false);
                }
            }
        })().then(() => {}, () => {});
    }, [saveClicked]);

    return (
        <Fullscreen className={className}>
            <FixedTopBar back title="Send a Message" border={false} black save/>
            <Main>
                <Form autocomplete="off">

                    <Stack spacing={5}>

                        <FormControl>
                            <FormLabel>Recipient</FormLabel>
                            <Input type="recipient"
                                   value={message.recipient}
                                   onChange={(e) => set('recipient')(e.currentTarget.value)}
                                   maxLength="30"
                                   required
                                   autoComplete="off" />
                        </FormControl>

                        <FormControl>
                            <FormLabel>Title</FormLabel>
                            <Input type="subject"
                                   value={message.subject}
                                   onChange={(e) => set('subject')(e.currentTarget.value)}
                                   maxLength="255"
                                   required
                                   autoComplete="off" />
                        </FormControl>

                        <FormControl>
                            <FormLabel>Message</FormLabel>
                            <Textarea type="content" value={message.content} rows={5} maxLength={'15000'}
                                      onChange={(e) => set('content')(e.currentTarget.value)}
                            />
                        </FormControl>

                    </Stack>

                </Form>
            </Main>
        </Fullscreen>
    );
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : theme.white_0};
  
  ${Form} {
    margin-top: 16px;
  }

  ${Footer} {
    width: calc(100% - 42px);
    margin: 0 auto;
  }
  
`;

export default Send;
